import './walletCard.scss';
import Wallet from '../../../assets/images/icons/digital-wallet.png';

import { useAppSelector } from '../../../features';
import { getUserInfo } from '../../../store/UserSlice';
import { textFormatterWalletHiddenChars } from '../../../utils/textFormatter';
import { networksImg, walletNetworkVerification } from '../../../utils/verification';
import Skeleton from '../../utils/skeleton/skeleton';

import React, { useEffect, useState } from "react"

export const WalletCard : React.FC = () => {

    const [copyStatus, setCopyStatus] = useState<boolean>(false);
    const [imageUrl, setImageUrl] = useState<string | undefined>(undefined)

    const info : any = useAppSelector(getUserInfo);

    const handleCopy = () => {
        if(info.wallet.hash_address) {
            navigator.clipboard.writeText(info.wallet.hash_address).then(function() {
                console.log('Async: Copying to clipboard was successful!');
                setCopyStatus(true);

                const timer = setTimeout( () => {
                    clearTimeout(timer)
                    setCopyStatus(false);
                }, 3000);
            }, function(err) {
                console.error('Async: Could not copy text: ', err);
            });
        }
    }

    useEffect( () => {
        if (info) {
            if (info.wallet && walletNetworkVerification(info.wallet.hash_address).toLowerCase().includes('ethe')) {
                setImageUrl(networksImg.eth);
            }
        } else {
            console.error('on info for ya')
        }
    }, [info?.wallet?.hash_address])

    return(
        <>
            <h1 className="category-title step-2">Wallet Info</h1>
            <div className="wallet-info step-2">
                <h1>
                    Wallet Configurada
                    <small>Essa será a wallet que o dinheiro será enviado quando o saque for pedido:</small>
                </h1>
                
                <div className='wallet' onClick={() => handleCopy()}>
                    <img src={Wallet} alt="" />
                    {info && Object.keys(info).length > 0 && (
                        <>
                            { copyStatus ? (
                                <p className='text-success'>Copiado!</p>
                            ):(
                                <p>
                                    {textFormatterWalletHiddenChars(info.wallet.hash_address, 6)}
                                </p>
                            )}
                        </>
                    )}
                    {info && Object.keys(info).length === 0 && (
                        <>
                            <Skeleton variant="text" />
                        </>
                    )}
                </div>
                
                <div className="wallet-network">
                    <div>
                        {info && Object.keys(info).length > 0 && (
                            <>
                                <p className='flex'><img src={imageUrl} /> {walletNetworkVerification(info.wallet.hash_address)}</p>
                            </>
                        )}
                        {info && Object.keys(info).length === 0 && (
                            <>
                                <Skeleton variant="text" />
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
};